import type { LocaleMessageBundle } from '../../types'

export const validationMessages: LocaleMessageBundle = {
  vi: {
    'validation.required': '{field} là bắt buộc',
    'validation.invalid': '{field} không hợp lệ',
    'validation.date': '{field} không hợp lệ',
    'validation.dateFormat': '{field} không đúng format {format}',
    'validation.minLength': '{field} phải có ít nhất {min} ký tự',
    'validation.maxLength': '{field} không được vượt quá {max} ký tự',
    'validation.size': '{field} phải có đúng {size} ký tự',
    'validation.afterOrEqual': '{field} phải lớn hơn hoặc bằng {other}',
    'validation.confirmed': '{field} xác nhận không khớp',
    'validation.tenantCode': 'Chỉ dùng chữ thường, số và dấu gạch ngang',
    'validation.username': 'Nhập email hoặc số điện thoại hợp lệ',
    'validation.passwordMin': 'Mật khẩu phải có ít nhất 6 ký tự',
    'validation.email': 'Email không hợp lệ',
    'validation.phone': 'Số điện thoại không hợp lệ',
    'validation.lettersOnly': '{field} chỉ dùng chữ cái, dấu cách và dấu nháy',
    'validation.textOnly': '{field} chỉ dùng chữ cái, số và dấu câu cơ bản',
    'validation.number': 'Giá trị phải là số',
    'validation.numeric': '{field} phải là số',
    'validation.integer': 'Giá trị phải là số nguyên',
    'validation.min': 'Giá trị phải lớn hơn hoặc bằng {min}',
    'validation.max': 'Giá trị phải nhỏ hơn hoặc bằng {max}',
    'validation.between': '{field} phải nằm trong khoảng từ {min} đến {max}',
    'validation.endAfterStart': 'Thời gian kết thúc phải sau thời gian bắt đầu',

    'common.description': 'Mô tả',
    'common.date': 'Ngày',

    'api.fields.name': 'Tên',
    'api.fields.code': 'Mã',
    'api.fields.description': 'Mô tả',
    'api.fields.status': 'Trạng thái',
    'api.fields.password': 'Mật khẩu',
    'api.fields.username': 'Tên đăng nhập',
    'api.fields.phone': 'Số điện thoại',
    'api.fields.email': 'Email',
    'api.fields.employee_code': 'Mã nhân viên',
    'api.fields.full_name': 'Họ tên',
    'api.fields.parent_id': 'Vị trí cha',
    'api.fields.location_id': 'Vị trí',
    'api.fields.quantity': 'Số lượng',
    'api.fields.items': 'Danh sách vị trí',
    'api.fields.usage_limit_total': 'Tổng lượt sử dụng',
    'api.fields.usage_limit_per_customer': 'Lượt sử dụng/khách hàng',
    'api.fields.usage_limit_per_staff': 'Lượt sử dụng/nhân viên',
    'api.fields.discount_value': 'Giá trị giảm',
    'api.fields.min_order_amount': 'Giá trị đơn tối thiểu',
    'api.fields.max_discount_amount': 'Giảm tối đa',
    'api.fields.purchase_quantity': 'Số lượng nhập',
    'api.fields.unit_cost': 'Đơn giá',
    'api.fields.supplier_id': 'Nhà cung cấp',
    'api.fields.purchase_unit_id': 'Đơn vị nhập',
    'api.fields.material_product_id': 'Nguyên vật liệu',
    'api.fields.output_product_id': 'Thành phẩm',
    'api.fields.output_quantity': 'Số lượng thành phẩm',
    'api.fields.recipe_id': 'Định mức sản xuất',
    'api.fields.production_date': 'Ngày sản xuất',
    'api.fields.branch_id': 'Chi nhánh',
    'api.fields.procurements': 'Chuẩn bị nhập nguyên vật liệu thiếu',
    'api.fields.guest_count': 'Số lượng khách',
    'api.fields.arrival_time': 'Thời gian đến',
    'api.fields.duration': 'Thời lượng',
    'api.fields.customer_name': 'Tên khách hàng',
    'api.fields.customer_phone': 'Số điện thoại',
    'api.fields.table_ids': 'Bàn',
    'api.fields.deposit_amount': 'Tiền đặt cọc',
    'api.fields.deposit_method': 'Phương thức đặt cọc',
    'api.fields.deposit_action': 'Xử lý đặt cọc',
    'api.fields.refund_payment_method': 'Phương thức hoàn tiền',
    'api.fields.sale_price': 'Giá bán',
    'api.fields.retail_price': 'Giá bán lẻ',
    'api.fields.cost_price': 'Giá nhập gần nhất',
    'api.fields.unit_conversions': 'Đơn vị quy đổi',
  },
  en: {
    'validation.required': '{field} is required',
    'validation.invalid': '{field} is invalid',
    'validation.date': '{field} is invalid',
    'validation.dateFormat': '{field} invalid format {format}',
    'validation.minLength': '{field} must be at least {min} characters',
    'validation.maxLength': '{field} must not exceed {max} characters',
    'validation.size': '{field} must be exactly {size} characters',
    'validation.afterOrEqual': '{field} must be after or equal to {other}',
    'validation.confirmed': '{field} confirmation does not match',
    'validation.tenantCode': 'Use lowercase letters, numbers, and dashes only',
    'validation.username': 'Enter a valid email or phone number',
    'validation.passwordMin': 'Password must be at least 6 characters',
    'validation.email': 'Invalid email address',
    'validation.phone': 'Invalid phone number',
    'validation.lettersOnly': '{field} may only contain letters, spaces and apostrophes',
    'validation.textOnly': '{field} may only contain letters, numbers and basic punctuation',
    'validation.number': 'Value must be a number',
    'validation.numeric': '{field} must be a number',
    'validation.integer': 'Value must be an integer',
    'validation.min': 'Value must be greater than or equal to {min}',
    'validation.max': 'Value must be less than or equal to {max}',
    'validation.between': '{field} must be between {min} and {max}',
    'validation.endAfterStart': 'End time must be after start time',

    'common.description': 'Description',
    'common.date': 'Date',

    'api.fields.name': 'Name',
    'api.fields.code': 'Code',
    'api.fields.description': 'Description',
    'api.fields.status': 'Status',
    'api.fields.password': 'Password',
    'api.fields.username': 'Username',
    'api.fields.phone': 'Phone',
    'api.fields.email': 'Email',
    'api.fields.employee_code': 'Employee code',
    'api.fields.full_name': 'Full name',
    'api.fields.parent_id': 'Parent location',
    'api.fields.location_id': 'Location',
    'api.fields.quantity': 'Quantity',
    'api.fields.items': 'Location list',
    'api.fields.usage_limit_total': 'Total usage limit',
    'api.fields.usage_limit_per_customer': 'Limit per customer',
    'api.fields.usage_limit_per_staff': 'Limit per staff',
    'api.fields.discount_value': 'Discount value',
    'api.fields.min_order_amount': 'Minimum order amount',
    'api.fields.max_discount_amount': 'Maximum discount',
    'api.fields.purchase_quantity': 'Purchase quantity',
    'api.fields.unit_cost': 'Unit cost',
    'api.fields.supplier_id': 'Supplier',
    'api.fields.purchase_unit_id': 'Purchase unit',
    'api.fields.material_product_id': 'Material',
    'api.fields.output_product_id': 'Output product',
    'api.fields.output_quantity': 'Output quantity',
    'api.fields.recipe_id': 'Manufacturing recipe',
    'api.fields.production_date': 'Production date',
    'api.fields.branch_id': 'Branch',
    'api.fields.procurements': 'Shortage procurement',
    'api.fields.guest_count': 'Guest count',
    'api.fields.arrival_time': 'Arrival time',
    'api.fields.duration': 'Duration',
    'api.fields.customer_name': 'Customer name',
    'api.fields.customer_phone': 'Customer phone',
    'api.fields.table_ids': 'Tables',
    'api.fields.deposit_amount': 'Deposit amount',
    'api.fields.deposit_method': 'Deposit method',
    'api.fields.deposit_action': 'Deposit action',
    'api.fields.refund_payment_method': 'Refund payment method',
    'api.fields.sale_price': 'Sale price',
    'api.fields.retail_price': 'Retail price',
    'api.fields.cost_price': 'Cost price',
    'api.fields.unit_conversions': 'Unit conversions',
  },
}
